<template>
  <ClientMemberList />
</template>

<script>
import ClientMemberList from "../Team/components/ClientMemberList";

export default {
  name: "ClientMembers",
  components: {
    ClientMemberList,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
